<ng-container *ngIf="state$ | async; let state">
    <ng-container
        *ngIf="
            state.document.metadata && !state.document.beingBuilt;
            else noDocument
        "
    >
        <div class="pdf-renderer-container">
            <div class="zas-pdf-viewer-toolbar">
                <a
                    class="zas-pdf-viewer-toolbar-item zas-pdf-viewer-toolbar-item-action-available toolbar-link"
                    (click)="openInNewTab(state.document.document)"
                >
                    <span class="icon-external-link"></span>
                </a>
                <span
                    class="zas-pdf-viewer-toolbar-item zas-pdf-viewer-toolbar-item-action-available"
                    (click)="
                        consultationService.downloadDocument(
                            state.document.metadata
                        )
                    "
                >
                    <span class="icon-download"></span>
                </span>
                <span
                    class="zas-pdf-viewer-toolbar-item zas-pdf-viewer-toolbar-item-action-available"
                    (click)="showEmailSendForm(state.cp)"
                    *ngIf="!hideEmailFunction"
                >
                    <span class="icon-mail-outline"></span>
                </span>
                <span class="zas-pdf-viewer-toolbar-item"></span>

                <span
                    class="zas-pdf-viewer-toolbar-item"
                    [class.zas-pdf-viewer-toolbar-item-action-available]="
                        !state.esignView.onFirstPage
                    "
                    [class.zas-pdf-viewer-toolbar-item-action-not-available]="
                        state.esignView.onFirstPage
                    "
                    (click)="goToFirstPage(state)"
                >
                    <span class="icon-arrow-breadcrumb2"></span
                    ><span
                        class="icon-arrow-breadcrumb2"
                        style="margin-left: -10px"
                    ></span>
                </span>
                <span
                    class="zas-pdf-viewer-toolbar-item"
                    [class.zas-pdf-viewer-toolbar-item-action-available]="
                        !state.esignView.onFirstPage
                    "
                    [class.zas-pdf-viewer-toolbar-item-action-not-available]="
                        state.esignView.onFirstPage
                    "
                    (click)="goToPrevPage(state)"
                >
                    <span class="icon-arrow-breadcrumb2"></span>
                </span>

                <span class="zas-pdf-viewer-toolbar-item" style="width: 100px">
                    <input
                        type="number"
                        [ngModel]="state.document.currentPage"
                        (ngModelChange)="onPageNumberChange(state, $event)"
                        style="width: 38px; color: black"
                    />
                    / {{ state.document.pageCount }}
                </span>

                <span
                    class="zas-pdf-viewer-toolbar-item"
                    [class.zas-pdf-viewer-toolbar-item-action-available]="
                        !state.esignView.onLastPage
                    "
                    [class.zas-pdf-viewer-toolbar-item-action-not-available]="
                        state.esignView.onLastPage
                    "
                    (click)="goToNextPage(state)"
                >
                    <span class="icon-arrow-breadcrumb"></span>
                </span>
                <span
                    class="zas-pdf-viewer-toolbar-item"
                    [class.zas-pdf-viewer-toolbar-item-action-available]="
                        !state.esignView.onLastPage
                    "
                    [class.zas-pdf-viewer-toolbar-item-action-not-available]="
                        state.esignView.onLastPage
                    "
                    (click)="goToLastPage(state)"
                >
                    <span class="icon-arrow-breadcrumb"></span
                    ><span
                        class="icon-arrow-breadcrumb"
                        style="margin-left: -10px"
                    ></span>
                </span>

                <span class="zas-pdf-viewer-toolbar-item"></span>
                <span class="zas-pdf-viewer-toolbar-item"></span>
                <span
                    *ngIf="mayUseQRCode"
                    class="zas-pdf-viewer-toolbar-item zas-pdf-viewer-toolbar-item-action-available"
                    (click)="showQRCode()"
                >
                    <span class="icon-i-cta-mobile-phone"></span>
                </span>
                <span
                    class="zas-pdf-viewer-toolbar-item"
                    [class.zas-pdf-viewer-toolbar-item-action-available]="
                        state.esignView.hasFields
                    "
                    [class.zas-pdf-viewer-toolbar-item-action-not-available]="
                        !state.esignView.hasFields
                    "
                    (click)="
                        state.esignView.hasFields && showSignAll(state.document)
                    "
                >
                    <span class="icon-handshake"></span>
                </span>
            </div>
            <zbd-pdf-renderer
                [page]="state.document.currentPage"
                style="display: block"
                (signFieldClicked)="onSignFieldClicked($event)"
            ></zbd-pdf-renderer>
            <div class="zas-row"></div>
            <div *ngIf="!state.cp.IsFinished" class="zas-row">
                <div class="zas-main-col" style="padding-right: 0px">
                    <button
                        type="button"
                        class="zas-button-thin zas-button-cta-abschluss"
                        style="float: right"
                        [disabled]="!state.esignView.canFinalize"
                        (click)="finalizeProtocol(state.cp.ConsultationProcess)"
                    >
                        <span class="icon-icon-cta"></span>
                        <span class="button-label"
                            >Beratungsdokumentation abschließen</span
                        >
                    </button>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #noDocument>
        <div *ngIf="state.document.beingBuilt">
            <div class="waiting">
                <span class="icon-loop spinning"></span>
                <span class="message"
                    >Das Dokument wird gerade erstellt ...</span
                >
            </div>
            <div *ngIf="!state.document.beingBuilt">
                <span>Das Dokument kann nicht angezeigt werden.</span>
            </div>
        </div>
    </ng-template>
</ng-container>

<sign-all-modal (signRequest)="onSignFieldClicked($event)"></sign-all-modal>
<sign-modal></sign-modal>
<qr-code-modal (onClose)="onQRCodeClosed()"></qr-code-modal>
<email-form-modal></email-form-modal>
<finalizing-modal></finalizing-modal>
